import { IComponentOptions } from 'angular';

export const ToolGroupComponent: IComponentOptions = {
  template: require('./tool-group.html'),
  bindings: {
    groupTitle: '@',
    toolGroup: '=',
  },
};

angular.module('nv.directives.tool-group').component('nvToolGroup', ToolGroupComponent);
